import {useSelector} from "react-redux";

export const useRequireRegister = () => {
    const {registerData} = useSelector(state => state.registration);

    return !!registerData.uid;
};